export const businessLogic = {
  cancellationCutOffMinutes: 20,
  returnCutOffDays: 30,
  loyaltyTiers: {
    1: {
      name: "White",
      lowerBound: 0,
      upperBound: 189.99,
    },
    2: {
      name: "Grey",
      lowerBound: 190,
      upperBound: 379.99,
    },
    3: {
      name: "Black",
      lowerBound: 380,
      upperBound: 570,
    },
  },
  lowStockQuantity: 10,
  signupDelaySeconds: 30,
  maxCartTotalQuantity: null,
  maxCartProductQuantity: null,
};

export const regionFeatureToggles = {
  gbp: {
    smsStockNotificationsEnabled: true,
    phoneNumberSignUp: true,
    eddEnabled: true,
    newLoyalty: true,
  },
  aud: {
    smsStockNotificationsEnabled: true,
    phoneNumberSignUp: true,
    eddEnabled: true,
    newLoyalty: true,
  },
  usd: {
    smsStockNotificationsEnabled: true,
    phoneNumberSignUp: true,
    eddEnabled: true,
    newLoyalty: true,
  },
  eur: {
    smsStockNotificationsEnabled: false,
    phoneNumberSignUp: false,
    eddEnabled: true,
    newLoyalty: true,
  },
};

export const klaviyoLists = {
  gbp: {
    accountId: "KKdVHx",
    listId: "PBQpGD",
  },
  aud: {
    accountId: "QLUUqb",
    listId: "LuKxsY",
  },
  usd: {
    accountId: "LvLjjr",
    listId: "N6CnRv",
  },
  eur: {
    accountId: "Q8ECcx",
    listId: "Jxz7Q4",
  },
};

export const localeUrls = {
  gbp: "ratandboa.com",
  aud: "aus.ratandboa.com",
  usd: "us.ratandboa.com",
  eur: "eur.ratandboa.com",
};

export const bannerMessage = {
  gbp: "Free shipping on all UK orders",
  aud: "Free shipping on all orders to Australia",
  usd: "Free shipping on all orders over $250",
  eur: "Free shipping on all orders over €220",
};

export const signUpBonus = {
  gbp: 20,
  aud: 40,
  usd: 30,
  eur: 20,
};

export const shippingRules = {
  gbp: {
    freeForCountry: "GB",
    freeAboveAmount: {
      amount: 200,
      currencyCode: "gbp",
    },
  },
  usd: {
    freeForCountry: "GB",
    freeAboveAmount: {
      amount: 250,
      currencyCode: "usd",
    },
  },
  aud: {
    freeForCountry: "AU",
    freeAboveAmount: null,
  },
  eur: {
    freeForCountry: null,
    freeAboveAmount: {
      amount: 200,
      currencyCode: "eur",
    },
  },
};

export const orderCutOffForNextDay = {
  gbp: {
    time: "14:00:00",
    timezone: "Europe/London",
  },
  aud: {
    time: "14:00:00",
    timezone: "Australia/Melbourne",
  },
  usd: {
    time: "14:00:00",
    timezone: "Europe/London",
  },
  eur: {
    time: "14:00:00",
    timezone: "Europe/Amsterdam",
  },
};
